<template>
  <div
    :class="[
      'select-container',
      !readonly ? 'grey-arrow' : '',
      !this.readonly || this.dark ? 'black-select-container-edit' : '',
    ]"
  >
    <select
      :class="dynamicClass"
      :disabled="readonly"
      :value="value"
      @input="onInput"
      @blur="$emit('blur')"
    >
      <option v-if="placeholder" :value="null" disabled>
        {{ placeholder }}
      </option>
      <slot></slot>
    </select>
    <div class="arrow"></div>
    <!-- <div
      v-if="(value === null || value === undefined) && placeholder"
      :class="['placeholder', !readonly ? 'active' : '', dark ? 'placeholder-dark': '']"
    >
      {{ placeholder }}
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number, Object, Array],
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(ev) {
      this.$emit("input", ev.target.value);
    },
  },
  computed: {
    dynamicClass() {
      return {
        "black-select": true,
        "black-select-edit": !this.readonly || this.dark,
        "black-select-dark": this.dark,
      };
    },
  },
};
</script>

<style scoped>
.black-select {
  position: relative;
  background: transparent;
  font-size: 2vh;
  width: 100%;
  text-align: center;
  padding: 0.3vh 1vh;
  border: 0.111vh solid transparent;
  border-radius: 0.444vh;
  color: white;
  -webkit-appearance: none;
  outline: none;
  z-index:1;
}

.black-select-edit {
  padding: 0.19vh 1vh;
  color: black;
}
.black-select-container-edit {
  background: #ffffff;
  border: 0.111vh solid #ededed;
}
.select-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.111vh solid #ededed;
  border-radius: 0.444vh;
}
.arrow {
  position: absolute;
  width: 1.555vh;
  height: 0.888vh;
  top: calc(50% - 0.444vh);
  right: 1.111vh;
  background-image: url(/icons/Arrow.svg);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
.placeholder {
  position: absolute;
  font-size: 2vh;
  color: #908f8d;
  z-index: 1;
}
.placeholder-dark {
  color: black !important;
}

.grey-arrow .arrow {
  background-image: url(/icons/ArrowGrey.svg);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 2;
}
.black-select-dark {
  border: 0.111vh solid #767674;
  background: #ededed !important;
}
option:disabled {
  color: #908f8d !important;
}
</style>
